interface Props {
  type: "veg" | "nonveg";
  size?: number;
}

const VegIcon = ({ type, size = 18 }: Props) => {
  const color = type === "veg" ? "#67AF7A" : "#F25138";
  return (
    <span className="inline-flex items-center justify-center border-2 rounded-[3px]" style={{ width: size, height: size, borderColor: color }} aria-label={type === "veg" ? "Vegetarian" : "Non-vegetarian"} >
      <span className={type === "veg" ? "rounded-full" : ""}
        style={{ width: size * 0.45, height: size * 0.45, backgroundColor: color, borderRadius: type === "veg" ? "50%" : 0 }}
      />
    </span>
  );
};

export default VegIcon;
